import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-image" }, null, -1)
const _hoisted_2 = { class: "container-fluid md:container mx-auto" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 place-items-center" }
const _hoisted_4 = { class: "text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pass_card = _resolveComponent("pass-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortPassesByName, (pass, Name) => {
          return (_openBlock(), _createBlock(_component_pass_card, {
            key: Name,
            pass: pass
          }, null, 8, ["pass"]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_4, "Letzer Stand der Daten: " + _toDisplayString(_ctx.getDate), 1)
    ])
  ], 64))
}